/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RefreshPublicReservationPaymentPathParameters } from 'api/actions/refresh-public-reservation-payment/refresh-public-reservation-payment-path-parameters';
import { RefreshPublicReservationPaymentResponse } from 'api/actions/refresh-public-reservation-payment/refresh-public-reservation-payment-response';

type RefreshPublicReservationPaymentQueryParameters = Record<string, any>;

/**
 * The path of the RefreshPublicReservationPayment action.
 */
export const refreshPublicReservationPaymentActionPath = new SweetPath<
  keyof RefreshPublicReservationPaymentPathParameters
>('/reservations/public/payments/{accessToken}/refresh', { path: '{param}' });

/**
 * Creates a contextualized RefreshPublicReservationPayment actions.
 */
export default function createRefreshPublicReservationPaymentAction(axios: AxiosInstance) {
  return function refreshPublicReservationPaymentAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RefreshPublicReservationPaymentPathParameters;
    query?: RefreshPublicReservationPaymentQueryParameters;
  }) {
    const path = refreshPublicReservationPaymentActionPath.insert(parameters);

    return axios.post<RefreshPublicReservationPaymentResponse, RefreshPublicReservationPaymentResponse>(path, {
      params: query,
      headers,
    });
  };
}
